import React from "react"
import { GetStaticProps, GetStaticPropsResult } from "next"
import { webUrl } from "../config/web"
import { getAllProducts, ProductsColorsItem } from "../lib/contentful/product/getAllProducts"
import { Entry } from "contentful"
import { TypeProductEntitySkeleton } from "../lib/contentful/ContentfulVzdelanibudoucnostiTypes"
import { isProductAvailable } from "../lib/prismic/getCourse"
import { CoursePage } from "../components/CoursePage/CoursePage"
import { dev } from "../lib/dev"

const CommonCoursePage = ({ openTraineeCourses, openNotTraineeCourses, productsColors }: Props) => {
  return (
    <CoursePage
      title="Programování pro děti online"
      description="Vítejte na naší stránce věnované kurzům programování pro děti."
      url={`${webUrl}/programovani-pro-deti-online`}
      h1="Programování pro děti online"
      text="Vítejte na naší stránce věnované kurzům programování pro děti! Zde nacházíte svět plný tvůrčího myšlení, inovací a především zábavy. Naše kurzy programování pro děti jsou navrženy tak, aby vybudovaly základní dovednosti a pochopení potřebné pro navigaci v digitálním světě. Nejenže děti naučíme psát kód, ale také jim ukážeme, jak může být programování kreativní a vzrušující."
      productsColors={productsColors}
      openSelectedCourses={openTraineeCourses}
      openAnotherCourses={openNotTraineeCourses}
    />
  )
}

interface Props {
  openTraineeCourses: Entry<TypeProductEntitySkeleton, undefined, string>[]
  openNotTraineeCourses: Entry<TypeProductEntitySkeleton, undefined, string>[]
  productsColors: ProductsColorsItem[]
}

export const getStaticProps: GetStaticProps = async (): Promise<GetStaticPropsResult<Props>> => {
  const contentfulProducts = await getAllProducts({ "fields.subType[in]": ["course"] })
  const openTraineeCourses = contentfulProducts.products.items.filter((p) => isProductAvailable(p))

  return {
    props: {
      openTraineeCourses,
      openNotTraineeCourses: [],
      productsColors: contentfulProducts.productsColors
    },
    revalidate: dev ? 1 : 120
  }
}

export default CommonCoursePage
